import { useAuth } from "./AuthContext";

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

export async function isUserEnrolledInCourse(token, courseId) {
    const userData = await getUserData(token);
    return Array.isArray(userData.courses_enrolled) && userData.courses_enrolled.includes(courseId);
  }  

export async function getUserData(token) {    
  const response = await fetch(`${baseAPI_URL}/users/get-user-data`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch user data');
  }
  return await response.json();
}

export async function getAnyUserData(token, userId) {    
  const response = await fetch(`${baseAPI_URL}/users/get-user-data/${userId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch user data');
  }
  return await response.json();
}

export async function enrollUserInCourse(token, courseId) { 
  const response = await fetch(`${baseAPI_URL}/users/enroll-user-in-course`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ course_id: courseId }),
  });

  if (!response.ok) {
    throw new Error('Failed to enroll user in course');
  }
  return await response.json();
}

/**
 * Search users by name or slug (partial, case-insensitive).
 * GET /users/search?q=&offset=&limit=
 */
export async function searchUsers(token, { q, offset = 0, limit = 20 } = {}) {
  const term = (q || "").trim();
  if (!term) {
    return { users: [], offset: 0, limit, total: 0, has_next: false, has_prev: false };
  }
  const params = new URLSearchParams({
    q: term,
    offset: String(offset),
    limit: String(limit),
  });
  const response = await fetch(`${baseAPI_URL}/users/search?${params}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || "Não foi possível buscar usuários.");
  }
  return data;
}

/**
 * List users with optional account type, profile, search, and sort.
 * GET /users/list-users?offset=&limit=&account_type=&profile=&q=&sort_by=&sort_order=
 * account_type (optional): free | paid — omit for all
 * profile (optional): none | has_profile_image | profiles_complete
 */
export async function listUsers(
  token,
  {
    offset = 0,
    limit = 20,
    account_type,
    profile,
    q,
    sort_by = "name",
    sort_order = "asc",
  } = {}
) {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
    sort_by,
    sort_order,
  });

  if (account_type === "free" || account_type === "paid") {
    params.set("account_type", account_type);
  }

  if (profile && profile !== "none") {
    params.set("profile", profile);
  }

  const term = (q || "").trim();
  if (term) {
    params.set("q", term);
  }

  const response = await fetch(`${baseAPI_URL}/users/list-users?${params}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || "Não foi possível carregar a lista de usuários.");
  }
  return data;
}
